import React from "react";
import Navbar from "../components/Navbar";
import { Footer } from "../components/footer";
import CropStoryCard from "../components/crops/CropStoryCard";
import useDocumentMeta from "../hooks/useDocumentMeta";
import cropsData from "../data/crops.json";

/**
 * /crops — index of crop story pages. Each card links to /crops/:slug.
 */
export default function Crops({ lang = "EN", toggleLanguage }) {
  const isAr = lang === "AR";

  useDocumentMeta({
    title: isAr
      ? "محاصيل مصر على فارمتوبيا — نماذج زراعية مدروسة"
      : "Egyptian Crops on FarmTopia — Researched Crop Models",
    description: isAr
      ? "تعرّف على نماذج محاصيل فارمتوبيا المصرية: القطن والقمح والطماطم والموالح وقصب السكر — مراحل النمو واحتياج المياه ومعاملات المحصول."
      : "Explore FarmTopia's Egyptian crop models — cotton, wheat, tomato, citrus and sugarcane: phenology, water need and crop coefficients from researched agronomy.",
  });

  return (
    <div dir={isAr ? "rtl" : "ltr"} className="bg-gray-50 min-h-screen">
      <Navbar lang={lang} toggleLanguage={toggleLanguage} />
      <main className="max-w-6xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-gray-900">
          {isAr ? "محاصيل مصرية، نماذج مدروسة علميًا" : "Egyptian crops, scientifically modelled"}
        </h1>
        <p className="mt-3 text-gray-600 max-w-2xl">
          {isAr
            ? "كل محصول تدعمه فارمتوبيا مبني على الأصناف والظروف الزراعية المصرية — مراحل النمو واحتياج المياه ومعاملات المحصول مستمدة من أبحاث علم الزراعة، لا من متوسطات عالمية."
            : "Every crop FarmTopia supports is modelled on Egyptian varieties and growing conditions — phenology, water need and crop coefficients drawn from researched agronomy, not global averages."}
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cropsData.crops.map((crop) => (
            <CropStoryCard key={crop.slug} crop={crop} lang={lang} />
          ))}
        </div>
      </main>
      <Footer lang={lang} />
    </div>
  );
}
